import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, Type } from '@angular/core';
import { ManageFormDataService } from './shared/manage-form.data.service';
import { ListaFormaDefault, FormaVersion, Tarea, Option, SeriePredeterminada, SubSeriePredeterminada, Static, QRTypes, QRCategorias, TypePreviewSticker } from '@app/shared';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import { find, isObject } from 'lodash';
import { Subject } from 'rxjs';

export interface NotifyTareaForma {
  id_forma: number;
  nombre: string;
  parametros: any;
  condicion: boolean;
}

interface OptionsPameters {
  aprobar_firmar: Option[];
  radicar: Option[];
  instance_liquidacion: Option[];
  inventario_expediente_documental_ac: Option[];
  publicacion: Option[];

}

@Component({
  selector: 'iw-manage-form',
  templateUrl: './manage-form.component.html',
  styleUrls: ['./manage-form.component.scss'],
  providers: [ManageFormDataService]
})
export class ManageFormComponent implements OnInit, OnDestroy {
  // Contiene la tarea
  @Input() sourceTask: Tarea;
  // Contiene las restricciones de documentos
  @Input() ListRestrict: any[];
  // Para mostrar información de debug.
  debug: boolean = environment.showDebugHelpers;
  // activa el combo de versiones
  activeVersion = false;
  // activa el combo de versiones
  activeParameters = false;
  // Contiene todas las versiones de las formas
  versions: any[] = [];
  // Contiene las versiones de la forma seleccionada
  versionSelect: Array<FormaVersion>;
  // Lista de los formularios a seleccionar
  forms: Array<ListaFormaDefault>;
  // formulario de formas
  formF: FormGroup = new FormGroup({
    form: new FormControl(null, [Validators.required]),
    version: new FormControl('', [Validators.required]),
    parameters: new FormControl(''),
    // serie: new FormControl(''),
    // subSerie: new FormControl(''),
    qrTipo: new FormControl(''),
    qrCategoria: new FormControl(''),
    typePreviewSticker: new FormControl(null),
  });
  // Parametros de las tareas, se definen con una key con el mismo nombre de la tarea
  // y las opciones en un array de posiciones
  parametersAll: OptionsPameters = {
    aprobar_firmar: [
      { value: 'aprobar', key: 'Aprobar' },
      { value: 'firmar', key: 'Firmar' },
      { value: 'validar_aprobacion_tarea', key: 'Validar aprobación por tarea actual' },
    ],
    radicar: [
      { value: 'asociar', key: 'Asociar radicado' },
      { value: 'generar', key: 'Generar radicado y subir documento' },
      { value: 'generar_sin_subir', key: 'Generar radicado' },
      { value: 'requerir_dependencia', key: 'Requerir dependencia' },
      { value: 'generarQR', key: 'Generar QR' },
      { value: 'asociar_expediente', key: 'Asociar expediente al generar radicado' },
      { value: 'escanear', key: 'Escanear documento' },
    ],
    instance_liquidacion: [
      { value: 'solo_asociacion', key: 'Solo asociación' }
    ],
    inventario_expediente_documental_ac: [
      { value: 'generar', key: 'Generar radicado y subir documento' },
      { value: 'requerir_periodo', key: 'Requerir periodo' },
    ],
    publicacion: [
      { value: 'validar_radicacion_especial', key: 'Validar radicacion especial' },
    ]
  };
  // parametros de la forma seleccionada
  parametersSelect: any[] = [];
  // define cuando mostrar los selectores de serie y subserie
  showSerie = false;
  // define cuando mostrar el selector de tipo de qr
  showTypeQr = false;
  // define cuando mostrar el selector de tipo de previzualizacion
  showTypePreview = false;
  // contiene las series documentales
  series: SeriePredeterminada[] = [];
  // contiene las series documentales
  subSeries: SubSeriePredeterminada[] = [];
  // serie de la forma seleccionada
  serieSelect: any = null;
  // contiene los tipos de qr disponibles
  qr: QRTypes[] = [];
  // contiene los tipos de qr disponibles
  qrCategorys: QRCategorias[] = [];
  // contiene los tipos de previsualizaciones disponibles
  typesPreviews: TypePreviewSticker[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Contiene si la forma tiene obligacion
  @Output() condiction: EventEmitter<boolean> = new EventEmitter();
  // Emite el id de la forma seleccionada
  @Output() idForm: EventEmitter<number> = new EventEmitter();

  @Output() formRestrition: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private mfds: ManageFormDataService,
    private toastr: ToastrService,) { }

  ngOnInit() {
    this.getTypeFormParameters();
    this.mfds.getForms().subscribe(forms => {
      this.forms = forms;
      this.forms.forEach(f => {
        this.versions[f.nombre] = f.versiones;
      });
      if (this.sourceTask) {
        if (this.sourceTask.tarea_forma) {
          this.loadingForm();
        }
      }
    });
    //  this.getSeries();
    this.getQRTypes();
    this.getQRCategory();
    this.getTypesPreview();

  }
  // getSeries() {
  //   this.mfds.getSeries().subscribe(series => {
  //     this.series = series;
  //   });
  // }

  // getSubSeries() {
  //   this.mfds.getSubSeries(this.serieSelect).subscribe(subseries => {
  //       this.subSeries = subseries;
  //   });
  // }

  getQRTypes() {
    this.mfds.getQRTypes().subscribe(qr_type => {
      this.qr = qr_type;
    });
  }

  getQRCategory() {
    this.mfds.getQRCategory().subscribe(qr_c => {
      this.qrCategorys = qr_c;
    });
  }

  getTypeFormParameters() {
    this.mfds.getTypeFormParameters().subscribe(async types => {
      if (types) {
        if (this.parametersAll["inventario_expediente_documental_ac"] && this.parametersAll["inventario_expediente_documental_ac"].length) {
          this.parametersAll["inventario_expediente_documental_ac"].length = 0;
          this.parametersAll["inventario_expediente_documental_ac"].push(
            { value: 'generar', key: 'Generar radicado y subir documento' },
            { value: 'requerir_periodo', key: 'Requerir periodo' },
          );
        } else {
          this.parametersAll["inventario_expediente_documental_ac"] = [];
          this.parametersAll["inventario_expediente_documental_ac"].push(
            { value: 'generar', key: 'Generar radicado y subir documento' },
            { value: 'requerir_periodo', key: 'Requerir periodo' },
          );
        }
        Static.asyncForEach(types, t => {
          this.parametersAll["inventario_expediente_documental_ac"].push({ value: t.nombre, key: t.nombre });
        });
      }
    });
  }

  getTypesPreview() {
    this.mfds.getTypesPreview().subscribe(types => {
      this.typesPreviews = types;
    });
  }

  paramersChage(e: any) {
    const show = find(e, { value: 'asociar' });
    const showQr = find(e, { value: 'generarQR' });
    const showTypePrev = find(e, { value: 'previewSticker' });
    if (show) {
      this.showSerie = true;
      this.formRestrition.emit(true);
    } else {
      this.showSerie = false;
      this.serieSelect = null;
      this.formRestrition.emit(false);
    }
    if (showQr) {
      this.showTypeQr = true;
    } else {
      this.showTypeQr = false;
      this.formF.controls['qrTipo'].setValue(null);
      this.formF.controls['qrCategoria'].setValue(null);
    }
    if (showTypePrev) {
      this.showTypePreview = true;
      this.formF.controls['typePreviewSticker'].setValue(null);
      this.formF.controls['typePreviewSticker'].setValidators([Validators.required]);
    } else {
      this.showTypePreview = false;
      this.formF.controls['typePreviewSticker'].setValue(null);
      this.formF.controls['typePreviewSticker'].clearValidators();
      this.formF.controls['typePreviewSticker'].reset();
    }
  }

  // serieChage(e: any) {
  //   if (e !== null || e !== undefined) {
  //     this.serieSelect = e;
  //     this.formF.controls['subSerie'].setValue(null);
  //     this.subSeries = [];
  //     // this.getSubSeries();
  //   } else {
  //     if (this.sourceTask.tarea_forma[0].parametros.hasOwnProperty('propiedades_asociacion')) {
  //         delete this.sourceTask.tarea_forma[0].parametros.propiedades_asociacion;
  //       }
  //     this.subSeries = [];
  //   }
  // }

  // subSerieChage(e: any) {
  //   if (e === null || e === undefined) {
  //     if (this.sourceTask.tarea_forma[0].parametros.hasOwnProperty('propiedades_asociacion')) {
  //       let pAsociacion = this.sourceTask.tarea_forma[0].parametros.propiedades_asociacion;
  //       delete pAsociacion.subserie;
  //     }
  //   }
  // }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Setea las versiones de la forma seleccionada en el combo de versiones
   *
   * @param {*} data
   * @memberof ManageFormComponent
   */
  versionByForm(data: any) {
    this.activeVersion = false;
    this.activeParameters = false;
    this.formF.controls['version'].reset('');
    this.formF.controls['parameters'].reset();
    if (data) {
      this.versionSelect = this.versions[data.nombre];
      this.versionSelect.sort((a, b) => a.version - b.version);
      this.activeVersion = true;
      if (data.forma_especifica) {
        if (this.parametersAll[data.nombre]) {
          this.parametersSelect = this.parametersAll[data.nombre];
          this.activeParameters = true;
          if (data.nombre == "publicacion") {
            this.formF.controls['parameters'].clearValidators();
          } else if (data.nombre == "instance_liquidacion") {
            this.formF.controls['parameters'].clearValidators();
          }
          else {
            this.formF.controls['parameters'].setValidators([Validators.required]);
          }


        } else {
          this.formF.controls['parameters'].clearValidators();
          this.formF.controls['parameters'].reset();
          delete this.parametersSelect;
        }
      } else {
        let checkSpecialRadication = find(data.versiones, { estilo: { special_radication: true } })
        let checkDocument = find(data.versiones, { documento: true })
        if (checkSpecialRadication) {
          this.parametersSelect = [
            { value: 'generarQR', key: 'Generar QR' },
            { value: 'previewSticker', key: 'Previsualización sticker' },
            { value: 'escanear', key: 'Escanear documento' },
          ];
          this.activeParameters = true;
          this.formF.controls['parameters'].clearValidators();
        } else if (checkDocument) {
          this.parametersSelect = [
            { value: 'escanear', key: 'Escanear documento' },
          ];
          this.activeParameters = true;
          this.formF.controls['parameters'].clearValidators();
        } else {
          this.formF.controls['parameters'].clearValidators();
          this.formF.controls['parameters'].reset();
          delete this.parametersSelect;
        }

      }
      if (
        this.sourceTask &&
        this.sourceTask.tarea_forma &&
        this.sourceTask.tarea_forma.length &&
        this.sourceTask.tarea_forma[0].condicion
      ) {
        this.condiction.emit(this.sourceTask.tarea_forma[0].condicion);
      }
    }
  }

  /**
   * Emite un evento para definir si la forma tiene condicion o no
   *
   * @param {*} data
   * @memberof ManageFormComponent
   */
  getCondiction(data: any) {
    const id = Number(data.target.value);
    this.idForm.emit(id);
    this.versionSelect.forEach(version => {
      if (id === version.id) {
        this.condiction.emit(version.condicion);
        if (!this.parametersAll[this.formF.controls['form'].value]) {
          if (version.radicado) {
            this.parametersSelect = this.parametersAll['radicar'];
            if (version.estilo['revisiones']) {
              this.parametersAll.aprobar_firmar.forEach(parameter => {
                this.parametersSelect.push(parameter);
              });
            }
            this.activeParameters = true;
            this.formF.controls['parameters'].setValidators([Validators.required]);
          } else if (version.estilo['revisiones']) {
            this.parametersSelect = this.parametersAll.aprobar_firmar;
            this.activeParameters = true;
            this.formF.controls['parameters'].setValidators([Validators.required]);
          } else if (version.estilo['special_radication']) {
            this.parametersSelect = [
              { value: 'generarQR', key: 'Generar QR' },
              { value: 'previewSticker', key: 'Previsualización sticker' },
              { value: 'escanear', key: 'Escanear documento' },
            ];
            this.activeParameters = true;
            this.formF.controls['parameters'].clearValidators();
          } else if (version.documento) {
            this.parametersSelect = [
              { value: 'escanear', key: 'Escanear documento' },
            ];
            this.activeParameters = true;
            this.formF.controls['parameters'].clearValidators();

          } else {
            this.formF.controls['parameters'].clearValidators();
            this.formF.controls['parameters'].reset();
            this.activeParameters = false;
            delete this.parametersSelect;
          }
        }
      }
    });
  }

  /**
   * Valida el formulario de forma y retorna este si es valido
   *
   * @returns {*}
   * @memberof ManageFormComponent
   */
  getForm(): any {
    if (this.formF.valid) {
      const parameters: any = new Object();
      if (this.activeParameters) {
        if (this.formF.controls['parameters'].value != null && this.formF.controls['parameters'].value != undefined) {
          this.formF.controls['parameters'].value.forEach((parameter: any) => {
            if (parameter !== "restrictiton_documents") {
              parameters[parameter] = true;
            }
          });
        }
        if (this.showSerie) {
          if (this.ListRestrict) {
            parameters['restrictiton_documents'] = this.ListRestrict;
          }
          // if (this.formF.controls['subSerie'].value){
          //   parameters['propiedades_asociacion'] = {
          //     serie: this.formF.controls['serie'].value,
          //     subserie: this.formF.controls['subSerie'].value
          //   };
          // } else if (this.formF.controls['serie'].value) {
          //   parameters['propiedades_asociacion'] = {
          //     serie: this.formF.controls['serie'].value,
          //   };
          // }
        } else {
          delete parameters['restrictiton_documents'];
        }

        if (this.showTypeQr) {
          if (this.formF.controls['qrTipo'].value) {
            parameters['qr_tipos'] = this.formF.controls['qrTipo'].value;
          }
          if (this.formF.controls['qrCategoria'].value) {
            parameters['qr_categoria'] = this.formF.controls['qrCategoria'].value;
          }
        }
        if (this.showTypePreview) {
          if (this.formF.controls['typePreviewSticker'].value) {
            parameters['typePreviewSticker'] = this.formF.controls['typePreviewSticker'].value;
          }
        }
      }
      const formSel = find(this.versionSelect, { id: Number(this.formF.controls['version'].value) });
      return <NotifyTareaForma>{
        id_forma: Number(this.formF.controls['version'].value),
        nombre: this.formF.controls['form'].value,
        parametros: parameters,
        condicion: formSel ? formSel.condicion : this.versionSelect[0].condicion
      };
    } else {
      this.toastr.error('Debe seleccionar una forma', 'Error en formas');
      return null;
    }
  }

  /**
   * Carga y setea el formulario con la informacion de la tarea
   *
   * @memberof ManageFormComponent
   */
  loadingForm() {
    this.forms.forEach(form => {
      form.versiones.forEach(version => {
        if (
          this.sourceTask.tarea_forma &&
          this.sourceTask.tarea_forma.length &&
          version.id === this.sourceTask.tarea_forma[0].id_forma
        ) {
          this.formF.controls['form'].setValue(form.nombre);
          this.versionByForm(form);
          if (!form.forma_especifica && (version.radicado || version.estilo['revisiones'])) {
            this.parametersSelect = this.parametersAll['radicar'];
            if (version.estilo['revisiones']) {
              this.parametersAll.aprobar_firmar.forEach(parameter => {
                this.parametersSelect.push(parameter);
              });
            }
            this.activeParameters = true;
            this.formF.controls['parameters'].setValidators([Validators.required]);
          }
          this.formF.controls['version'].setValue(this.sourceTask.tarea_forma[0].id_forma);
          const params: Array<any> = [];
          let qrTypesList: any = null;
          let qrCategory: any = null;
          let asociation: any = null;
          let TypesPreview: any = null;
          for (const key in this.sourceTask.tarea_forma[0].parametros) {
            if (this.sourceTask.tarea_forma[0].parametros.hasOwnProperty(key)) {
              if (key !== 'propiedades_asociacion' && key !== 'qr_tipos' && key !== 'qr_categoria' && key !== 'typePreviewSticker' && key != "restrictiton_documents") {
                params.push(key);
              } else if (key == 'qr_tipos') {
                qrTypesList = this.sourceTask.tarea_forma[0].parametros[key];
              } else if (key == 'qr_categoria') {
                qrCategory = this.sourceTask.tarea_forma[0].parametros[key];
              } else if (key == 'typePreviewSticker') {
                TypesPreview = this.sourceTask.tarea_forma[0].parametros[key];
              } else {
                asociation = this.sourceTask.tarea_forma[0].parametros[key];
              }

            }
          }
          if (params.includes('asociar')) {
            this.showSerie = true;
          } else {
            this.showSerie = false;
            this.serieSelect = null;
          }
          if (params.includes('generarQR')) {
            this.showTypeQr = true;
            this.formF.controls['qrTipo'].setValue(qrTypesList);
            this.formF.controls['qrCategoria'].setValue(qrCategory);

          } else {
            this.showTypeQr = false;
          }
          if (params.includes('previewSticker')) {
            this.showTypePreview = true;
            this.formF.controls['typePreviewSticker'].setValue(TypesPreview);
            this.formF.controls['typePreviewSticker'].setValidators([Validators.required]);

          } else {
            this.showTypePreview = false;
            this.formF.controls['typePreviewSticker'].setValue(null);
            this.formF.controls['typePreviewSticker'].clearValidators();
            this.formF.controls['typePreviewSticker'].reset();
          }
          this.formF.controls['parameters'].setValue(params);
          // this.formF.controls['serie'].setValue(asociation && asociation.serie ? asociation.serie : null);
          // if (asociation && asociation.serie) {
          //   this.serieSelect = find(this.series, {id: asociation.serie });
          //   this.getSubSeries();
          // }
          // this.formF.controls['subSerie'].setValue(asociation && asociation.subserie ? asociation.subserie : null);
        }
      });
    });
  }

  /**
   * Limpiar componente
   *
   * @memberof ManageFormComponent
   */
  empty() {
    this.formF.reset();
    delete this.sourceTask;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-form/manage-form.component.ts